module.exports = __webpack_public_path__ + "img/benjaminmoore-colorx.a5322e17.png";